


































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  ManagedTransfersActivityHistoryElement,
  ActivityHistoryStatus,
  ActivityHistoryType,
} from "@/shared/types";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { Location } from "vue-router";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    Pagination,
    Button,
    GenericLoadingSpinner
  }
})
export default class ManagedTransfersActivity extends Vue {
  drivewealthStore = useDrivewealthStore();

  @Prop() pageNumber: number;

  @Prop() routeToDrivewealthActivity: (pageNumber: number) => Location;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop() accountId: number;

  @Watch("$props", { deep: true })
  loadTable () {
    this.onPageNumberUpdated();
  }

  get isLoading () {
    return this.drivewealthStore.managedTransfersActivityLoading;
  }

  get hasTransfers () {
    return this.drivewealthStore.managedTransfersActivityLoaded &&
        this.drivewealthStore.managedTransfersActivity.length > 0;
  }

  created () {
    this.onPageNumberUpdated();
  }

  @Watch("pageNumber")
  onPageNumberUpdated () {
    this.drivewealthStore.setManagedTransfersActivityPageNumber(this.pageNumber);
    if (this.accountId) {
      this.drivewealthStore.loadManagedTransfersActivityByAccount(
          { username: this.username, partnerId: this.partnerId, accountId: this.accountId });
    } else {
      this.drivewealthStore.loadManagedTransfersActivity({ username: this.username, partnerId: this.partnerId });
    }
  }

  formatDate (date?: moment.Moment) {
    if (!date) {
      return "";
    }
    return moment(date).format("MMM D, YYYY");
  }

  formatCurrency (currency, digits) {
    return formatCurrency(currency, digits);
  }

  onPageChanged (pageNumber: number) {
    this.routeToDrivewealthActivity(pageNumber);
  }

  getAmount (p: ManagedTransfersActivityHistoryElement) {
    if (p.status === ActivityHistoryStatus.Pending
        && p.type === ActivityHistoryType.ManagedInvestmentTransferSellLiquidation
        && p.dollarAmount === 0) {
      return "—";
    }

    return this.formatCurrency(p.dollarAmount, 2);
  }

  getDescriptiveType (type: string, investmentFeeDescription: string): string {
    switch (type) {
      case ActivityHistoryType.ManagedInvestmentTransferBuy:
        return "Transfer to Managed";
      case ActivityHistoryType.ManagedInvestmentTransferSell:
        return "Transfer from Managed";
      case ActivityHistoryType.ManagedInvestmentTransferSellLiquidation:
        return "Liquidation";
      case ActivityHistoryType.ManagedInvestmentTransferBuyAutomated:
        return "Transfer to Managed (Automated)";
      case ActivityHistoryType.ManagedInvestmentTransferSellInvestmentFee:
        return investmentFeeDescription;
      default:
        return type;
    }
  }

  getDescriptiveStatus (status: string): string {
    switch (status) {
      case ActivityHistoryStatus.Pending:
        return "Pending";
      case ActivityHistoryStatus.Canceled:
        return "Canceled";
      case ActivityHistoryStatus.Failed:
        return "Failed";
      case ActivityHistoryStatus.Settled:
        return "Complete";
      default:
        return status;
    }
  }

  mapToTableItems (elements: ManagedTransfersActivityHistoryElement[]) {
    return elements.map((p, i) => ({
      request_date: this.formatDate(p.dateCreated),
      completed_date: p.settledDate ? this.formatDate(p.settledDate) : "—",
      transaction_type: this.getDescriptiveType(p.type, p.investmentFeeDescription),
      amount: this.getAmount(p),
      status: this.getDescriptiveStatus(p.status),

      id: p.status + i,
      _showDetails: false,
      canExpand: false
    }));
  }

  completedTableFields = [
    {
      key: "request_date",
      label: "Request Date",
      thClass: "text-left"
    },
    {
      key: "completed_date",
      label: "Completed Date",
      thClass: "text-left"
    },
    {
      key: "transaction_type",
      label: "Transaction Type",
      thClass: "text-left"
    },
    {
      key: "amount",
      label: "Amount",
      thClass: "text-left"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-left"
    },
  ];

  get completedTableItems () {
    return this.mapToTableItems(this.drivewealthStore.managedTransfersActivity);
  }
}
